document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.pack-contents__track');
  if (!track) return;

  const grid = track.querySelector('.pack-contents__grid');
  const slides = grid ? Array.from(grid.querySelectorAll('.pack-item')) : [];
  const dots = document.querySelectorAll('.pack-contents__dots-btn');

  if (!grid || !dots.length) return;

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };

  // The active card is the one whose left edge is closest to the track's scroll position. Reading the scroll
  // position (rather than which cards are visible) keeps card 1 active on load, even when several cards are on screen.
  const updateActiveDot = () => {
    const scrollStart = track.scrollLeft;
    const firstOffset = slides[0].offsetLeft;
    let activeIndex = 0;
    let closestDistance = Infinity;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - firstOffset - scrollStart);
      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });
    // At the end of the track the last card cannot scroll to the start, so treat the end as the last card
    if (scrollStart + track.clientWidth >= track.scrollWidth - 2) activeIndex = slides.length - 1;
    if (scrollStart <= 2) activeIndex = 0;
    setActiveDot(activeIndex);
  };

  let frame = null;
  track.addEventListener(
    'scroll',
    () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        updateActiveDot();
      });
    },
    { passive: true }
  );

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const slide = slides[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    });
  });

  updateActiveDot();
});
